import { api } from '@/internationalization/api-client'
import type { Patron, PatronRef, PatronSuggestion } from '@/types'

export const patronsApi = {
  /** Readable by anyone: it is needed to render a filter. */
  list: (includeArchived = false) =>
    api.get<Patron[]>('/patrons', { query: { includeArchived } }),

  /**
   * External domains on invites that no patron claims yet, commonest first.
   * ADMIN-only — it is a report over who the workspace has met.
   */
  suggestions: (limit = 20) =>
    api.get<PatronSuggestion[]>('/patrons/suggestions', { query: { limit } }),

  create: (body: { name: string; domains?: string[]; notes?: string | null }) =>
    api.post<Patron>('/patrons', body),

  update: (id: string, patch: { name?: string; status?: 'active' | 'archived'; notes?: string | null }) =>
    api.patch<Patron>(`/patrons/${id}`, patch),

  addDomain: (id: string, domain: string) =>
    api.post<Patron>(`/patrons/${id}/domains`, { domain }),

  removeDomain: (id: string, domain: string) =>
    api.delete<Patron>(`/patrons/${id}/domains/${encodeURIComponent(domain)}`),

  /**
   * Replace the MANUALLY attached patrons on a meeting. Invite-derived links
   * are not in scope and cannot be removed this way — that means removing the
   * domain from the patron itself.
   */
  setMeetingPatrons: (meetingId: string, patronIds: string[]) =>
    api.put<PatronRef[]>(`/meetings/${meetingId}/patrons`, { patronIds }),
}
